const getEnv = () => 'live';
const getDefualtParameters = (language: string, page: string) => ({
  bu: 'iavs',
  market: 'global',
  pageName: `trelleborg:${language}:iavs:${page ? page : 'Home'}`,
  pagePrimaryCategory: page ? page : 'Home',
  pageSecondaryCategory: '',
  pageTertiaryCategory: '',
  personaName: 'Unassignedprofile',
  language,
});

export const pdfEvent = (fileName: string) => {
  (window as any).dataLayer.push({
    event: 'engagement',
    eventCategory: 'Engagement - Downloads',
    eventAction: 'PDF',
    eventLabel: fileName,
  });
};

export const qouteEvent = () => {
  (window as any).dataLayer.push({
    event: 'salesLeadsTrack',
    eventCategory: 'Sales Leads',
    eventAction: 'AVS – Cable Entry System',
    eventLabel: 'Request quote',
  });
};

export const getGA = getDefualtParameters;
export default getEnv;
